<nb-card size="large">
  <nb-card-header><h3>{{titulo}}</h3></nb-card-header>
  <nb-card-body>
    <div *ngIf="data && schema">
      <ng-container *ngFor="let key of getOrderedKeys(data)">
        <ng-container
          *ngTemplateOutlet="renderField; context: { key: key, value: data[key], schema: schema.properties[key] }">
        </ng-container>
      </ng-container>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton status="primary" (click)="dismiss()">Cerrar</button>
  </nb-card-footer>
</nb-card>

<ng-template #renderField let-key="key" let-value="value" let-schema="schema">
  <!-- 🔹 Primitivos -->
  <ng-container *ngIf="!isObject(value) && !isArray(value)">
    <div class="field-row">
      <strong>{{ schema?.title || toDisplayName(key) }}</strong>: {{ value }}
    </div>
  </ng-container>

  <!-- 🔹 Objetos -->
  <ng-container *ngIf="isObject(value)">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title class="field-title">
          {{ schema?.title || toDisplayName(key) }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="object-children">
        <ng-container *ngFor="let childKey of objectKeys(value)">
          <ng-container *ngTemplateOutlet="renderField; context: {
            key: childKey,
            value: value[childKey],
            schema: schema?.properties ? schema.properties[childKey] : null
          }"></ng-container>
        </ng-container>
      </div>
    </mat-expansion-panel>
  </ng-container>

  <!-- 🔹 Arrays -->
  <ng-container *ngIf="isArray(value)">
    <!-- Caso 0 elementos: solo título sin desplegable -->
    <div *ngIf="value.length === 0" class="field-row">
      <strong>{{ schema?.title || toDisplayName(key) }} (0 elementos)</strong>
    </div>

    <!-- Caso >0 elementos: desplegable con contenido -->
    <mat-expansion-panel *ngIf="value.length > 0">
      <mat-expansion-panel-header>
        <mat-panel-title class="field-title">
          {{ schema?.title || toDisplayName(key) }}
          ({{ value.length }} {{ value.length === 1 ? 'elemento' : 'elementos' }})
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="array-items">
        <ng-container *ngFor="let item of value">
          <mat-card class="array-item-card">
            <div class="array-item-object">
              <ng-container *ngIf="isObject(item) || isArray(item); else primitiveItem">
                <ng-container *ngFor="let subKey of objectKeys(item)">
                  <ng-container *ngTemplateOutlet="renderField; context: {
                    key: subKey,
                    value: item[subKey],
                    schema: schema?.items?.properties ? schema.items.properties[subKey] : null
                  }"></ng-container>
                </ng-container>
              </ng-container>
              <ng-template #primitiveItem>
                <div class="field-row">{{ item }}</div>
              </ng-template>
            </div>
          </mat-card>
        </ng-container>
      </div>
    </mat-expansion-panel>

  </ng-container>
</ng-template>
